/**
 * 通用库函数
 */

import $ from 'jquery'
import config from '@/components/common/config'
import user from '@/components/common/user'
// import tools from '@/components/common/tools'
import {
  Loading
} from 'element-ui'

let isAjaxing = []
/**
 * 通用请求函数
 * @version 2.0
 * @param {object} options 配置项
 */
export const Ajax = (options) => {
  let $pageLoadingWrap = $('#page_loading_wrap')
  let ajaxDef = $.Deferred()
  let settings = $.extend({
    id: Guid(16), // ajax的id
    hasLoading: false, // 是否有loading
    loadingType: 0, // 0 - 全面loading, 1 - 页面内loading
    confirmTitle: false, // 是否有确认框
    api: true,
    url: '',
    data: {},
    type: 'post',
    async: true,
    timeout: 0,
    processData: true, // 序列化数据,formdata的时候需要false
    success: function () {}, // 请求成功回调 [resultData, msg, textStatus]
    fail: function () {}, // 请求失败回调 [errorMsg, msg, textStatus]
    error: function () {}, // 请求错误回调
    complete: function () {}, // 请求结束回调
    beforeSend: function () {}
  }, options)
  let loadingTimeout, loadingInstance
  let showLoading = () => {
    if (settings.hasLoading) {
      if (settings.loadingType === 0) {
        // 全屏loading
        loadingInstance = Loading.service({
          fullscreen: true
        })
      } else if (settings.loadingType === 1) {
        // 页面内loading
        $pageLoadingWrap.show()
        loadingInstance = Loading.service({
          target: $pageLoadingWrap[0],
          fullscreen: false
        })
      }
    }
  }
  let closeLoading = () => {
    if (settings.hasLoading && loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
      if (settings.loadingType === 1) {
        // 页面内loading
        $pageLoadingWrap.hide()
      }
    }
  }
  let ajax = () => {
    let ajaxStartTime = null
    let isError = false
    $.ajax({
      url: settings.api ? config.AjaxUrl + settings.url : settings.url,
      data: $.extend(settings.data, {
        token: user.getMemberToken()
      }),
      type: settings.type,
      async: settings.async,
      processData: settings.processData,
      success: function (response, textStatus) {
        let def = $.Deferred()
        if (typeof response === 'string') {
          try {
            response = JSON.parse(response)
          } catch (e) {}
        }
        if (settings.hasLoading && ajaxStartTime !== null) {
          // 有 loading 的情况下
          // 500ms 以内的请求不显示 loading, 超时显示 loading
          // loading 持续最少 300ms
          var ajaxTime = new Date().getTime() - ajaxStartTime
          if (ajaxTime < 500) {
            clearTimeout(loadingTimeout)
            def.resolve()
          } else if (ajaxTime < 900) {
            setTimeout(function () {
              closeLoading()
              def.resolve()
            }, 900 - ajaxTime)
          } else {
            closeLoading()
            def.resolve()
          }
        } else {
          def.resolve()
        }
        def.then(function () {
          isAjaxing[settings.id] = false
          if (response.issuccess === true) {
            // 返回数据
            settings.success.call(this, response, textStatus)
            ajaxDef.resolve(response)
          } else if (response.issuccess === false) {
            // 请求失败
            settings.fail.call(this, response, textStatus)
            ajaxDef.reject(response)
          } else {
            // response.issuccess 不存在
            settings.success.call(this, response, textStatus)
            ajaxDef.resolve(response)
          }
        })
      },
      error: function (xhr) {
        isError = true
        closeLoading()
        isAjaxing[settings.id] = false
        settings.error.call(this, xhr)
      },
      complete: function (xhr) {
        isAjaxing[settings.id] = false
        settings.complete.call(this, xhr)
      },
      beforeSend: function () {
        if (settings.hasLoading) {
          ajaxStartTime = new Date().getTime()
          loadingTimeout = setTimeout(() => {
            if (!isError) {
              showLoading()
            }
          }, 550)
        }
        isAjaxing[settings.id] = true
        settings.beforeSend.call(this)
      }
    })
  }
  isAjaxing[settings.id] || (isAjaxing[settings.id] = false)
  if (!isAjaxing[settings.id]) {
    ajax()
  }
  return ajaxDef
}

/**
 * 生成uuid, 默认rfc4122规范
 * @version 1.0
 * @param {number} len 生成的uuid位数, 不传使用rfc4122定义的
 * @param {number} radix 生成范围
 */
export const Guid = (len, radix) => {
  let chars, uuid, i, r
  chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  uuid = []
  radix = radix || chars.length
  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    // rfc4122, version 4 form
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('')
}

export default {
  Ajax: Ajax,
  Guid: Guid
}



// WEBPACK FOOTER //
// ./src/components/common/mc-lib.js